<template>
  <div class="px-4 cursor-pointer">
    <div class="rounded overflow-hidden shadow-lg">
      <div
        v-if="asset.type == 'image'"
        class="w-full object-cover mx-auto text-center py-8 bg-card text-white"
        alt="Sunset in the mountains"
      >
        <i class="fas fa-images text-5xl"></i>
      </div>
      <div
        v-else-if="asset.type == 'video'"
        class="w-full object-cover mx-auto text-center py-8 bg-card text-white"
        alt="Sunset in the mountains"
      >
        <i class="fas fa-video text-5xl"></i>
      </div>
      <div
        v-else-if="asset.type == 'audio'"
        class="w-full object-cover mx-auto text-center py-8 bg-card text-white"
        alt="Sunset in the mountains"
      >
        <i class="fas fa-volume-off text-5xl"></i>
      </div>
      <div
        v-else
        class="w-full object-cover mx-auto text-center py-8 bg-card text-white"
        alt="Sunset in the mountains"
      >
        <i class="far fa-file text-5xl"></i>
      </div>

      <div class="px-6 py-4">
        <div class="program-main mb-2 colored">
          {{ asset.asset_name }}
        </div>
        <div
          class=" program-content flex flex-wrap main-tenant-color justify-between"
        >
          <span class="capitalize">Type: {{ asset.type }}</span>
          <span @click="handleClick(asset.id)">Delete</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["asset"],
  methods: {
    ...mapActions(["deleteTenantAsset", "fetchTenantAssets"]),
    handleClick(id) {
      this.$confirm({
        message: `Are you sure you want to delete this Asset?`,
        button: {
          no: "No",
          yes: "Yes",
        },

        callback: (confirm) => {
          if (confirm) {
            this.deleteAsset(id);
          }
        },
      });
    },
    async deleteAsset(id) {
      this.errors = [];
      let res = await this.deleteTenantAsset({
        id,
      });

      if (res === true || res.status === 200 || res.status === 201) {
        this.form = {};
        this.fetchTenantAssets();
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Asset deleted succesfully",
        });

        this.close();
      } else {
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
                  ? res.data.errors[0].title
                  : "An error occured",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.program-main {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
}

.program-content {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
}
.bg-card {
  background-color: color(lms-tenant);
}
.colored {
  color: color(lms-tenant);
}
</style>
